export { BSModalContext, BSModalContextBuilder } from './modal-context';
export { BSModalContainer } from './modal-container.component';
export { BSMessageModal, BSMessageModalTitle, BSMessageModalBody, BSModalFooter } from './message-modal.component';
export { MessageModalPresetBuilder } from './presets/message-modal-preset';
export { ModalOpenContext, ModalOpenContextBuilder } from 'angular2-modal';
export { OneButtonPresetBuilder } from './presets/one-button-preset';
export { TwoButtonPresetBuilder, PromptPresetBuilder } from './presets/two-button-preset';
export { Modal, bootstrap4Mode } from './modal';
export { BootstrapModalModule, providers } from './bootstrap.module';
//# sourceMappingURL=bootstrap.js.map


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/angular2-modal/plugins/bootstrap/src/bootstrap.js
// module id = null
// module chunks = 